// Shopify analytics constants
const article = 'article';
const blog = 'blog';
const captcha = 'captcha';
const cart = 'cart';
const collection = 'collection';
const customersAccount = 'customers/account';
const customersActivateAccount = 'customers/activate_account';
const customersAddresses = 'customers/addresses';
const customersLogin = 'customers/login';
const customersOrder = 'customers/order';
const customersRegister = 'customers/register';
const customersResetPassword = 'customers/reset_password';
const giftCard = 'gift_card';
const home = 'index';
const listCollections = 'list-collections';
const forbidden = '403';
const notFound = '404';
const page = 'page';
const password = 'password';
const product = 'product';
const policy = 'policy';
const search = 'search';
export const PAGE_RENDERED_EVENT_NAME = 'page_rendered';
export const COLLECTION_PAGE_RENDERED_EVENT_NAME = 'collection_page_rendered';
export const PRODUCT_PAGE_RENDERED_EVENT_NAME = 'product_page_rendered';
export const PRODUCT_ADDED_TO_CART_EVENT_NAME = 'product_added_to_cart';
export const SEARCH_SUBMITTED_EVENT_NAME = 'search_submitted';
export const ShopifyAnalyticsConstants = {
    pageType: {
        article,
        blog,
        captcha,
        cart,
        collection,
        customersAccount,
        customersActivateAccount,
        customersAddresses,
        customersLogin,
        customersOrder,
        customersRegister,
        customersResetPassword,
        giftCard,
        home,
        listCollections,
        forbidden,
        notFound,
        page,
        password,
        product,
        policy,
        search,
    },
};
